interface SectionTitleProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionTitle({ eyebrow, title, desc, align = "left" }: SectionTitleProps) {
  const center = align === "center";
  return (
    <div className={`flex flex-col ${center ? "items-center text-center" : "items-start"} gap-3`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold tracking-wide text-secondary-900 whitespace-nowrap">
        <i className="ri-flashlight-fill text-sm text-secondary-700" aria-hidden="true" />
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl font-black text-foreground-900 md:text-3xl leading-snug">{title}</h2>
      {desc ? <p className="max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p> : null}
    </div>
  );
}